import { addMinutes, parseISO } from 'date-fns';

import { OjEvent } from '../../../shared/api';

export function fixFullDayEventStart(event: OjEvent): OjEvent {
  if (event.all_day) {
    const date = parseISO(event.start_at);
    const newDateString = addMinutes(
      date,
      date.getTimezoneOffset(),
    ).toISOString();

    return {
      ...event,
      start_at: newDateString,
    };
  }

  return event;
}
